import * as Types from '../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AgencySettingsQueryVariables = Types.Exact<{
  agencyId: Types.Scalars['ID'];
}>;


export type AgencySettingsQuery = { __typename?: 'Query', AgencySettings: { __typename?: 'AgencySettings', id: any, name?: string | null, etaInterval: number, externalId: number, latitude: number, longitude: number, defaultItineraryProvider?: string | null, courierDesignedItineraryProvider?: string | null, createdAt: any, isVisible: boolean, couriers: Array<{ __typename?: 'Courier', courierId: number, indicative?: string | null, etaInterval: number, defaultItineraryProvider?: string | null, courierDesignedItineraryProvider?: string | null }> } };


export const AgencySettingsDocument = gql`
    query AgencySettings($agencyId: ID!) {
  AgencySettings(agencyId: $agencyId) {
    id
    name
    etaInterval
    externalId
    latitude
    longitude
    defaultItineraryProvider
    courierDesignedItineraryProvider
    createdAt
    isVisible
    externalId
    couriers(agencyId: $agencyId, courierFiltering: ALL_COURIERS) {
      courierId
      indicative
      etaInterval
      defaultItineraryProvider
      courierDesignedItineraryProvider
    }
  }
}
    `;

/**
 * __useAgencySettingsQuery__
 *
 * To run a query within a React component, call `useAgencySettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgencySettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgencySettingsQuery({
 *   variables: {
 *      agencyId: // value for 'agencyId'
 *   },
 * });
 */
export function useAgencySettingsQuery(baseOptions: Apollo.QueryHookOptions<AgencySettingsQuery, AgencySettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgencySettingsQuery, AgencySettingsQueryVariables>(AgencySettingsDocument, options);
      }
export function useAgencySettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgencySettingsQuery, AgencySettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgencySettingsQuery, AgencySettingsQueryVariables>(AgencySettingsDocument, options);
        }
export type AgencySettingsQueryHookResult = ReturnType<typeof useAgencySettingsQuery>;
export type AgencySettingsLazyQueryHookResult = ReturnType<typeof useAgencySettingsLazyQuery>;
export type AgencySettingsQueryResult = Apollo.QueryResult<AgencySettingsQuery, AgencySettingsQueryVariables>;